import React from 'react';
import { Button, Form, Alert } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { TextField } from "../common/FormComponents";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faParagraph } from '@fortawesome/free-solid-svg-icons';

const validate = values => {
    const errors = {};
    if (!values.name) {
        errors.name = '* Required';
    } else if (values.name.length < 2) {
        errors.name = '* Must be more than 2 characters';
    }
    if (!values.age) {
        errors.age = '* Required';
    } else if (values.age < 16) {
        errors.age = '* 18+';
    }
    if (!values.gender) {
        errors.gender = '* Required';
    }
    if (!values.location) {
        errors.location = '* Required';
    } else if (values.location.length < 2) {
        errors.location = '* Must be more than 2 characters';
    }
    if (!values.technicalExpertise) {
        errors.technicalExpertise = '* Required';
    }
    if (!values.microphone) {
        errors.microphone = '* Required';
    }
    if (!values.pc) {
        errors.pc = '* Required';
    }
    if (!values.characterName) {
        errors.characterName = '* Required';
    } else if (values.characterName.length < 2) {
        errors.characterName = '* Must be more than 2 characters';
    }
    if (!values.characterClass) {
        errors.characterClass = '* Required';
    } else if (values.characterClass.length < 2) {
        errors.characterClass = '* Must be more than 2 characters';
    }
    if (!values.characterLevel) {
        errors.characterLevel = '* Required';
    }

    return errors;
};

const StepTwoForm = props => {
    const { handleSubmit } = props;

    return (
        <Form onSubmit={handleSubmit}>
            { props.questions.map((question, i) => (
                <div className="panel-adt" key={question.id}>
                    <h3>Question {i+1}</h3>
                    <div className="adt-flex-container">
                        <div className="adt-flex-item">
                            <p style={{margin:0}}>{question.question}</p>
                        </div>
                    </div>
                    <div className="adt-flex-container">
                        <div className="adt-flex-icon">
                            <FontAwesomeIcon className="text-primary" size="lg" icon={faParagraph} fixedWidth />
                        </div>
                        <div className="adt-flex-item">
                            <Field component={TextField}
                                name={"question|"+question.id}
                                type="text"
                                fullWidth
                                multiline
                                helperText={<span></span>}
                            />
                        </div>
                    </div>
                </div>
            ))
            }
            <div className="panel-adt clearfix">
                { props.errors ? (
                    <Alert bsStyle="danger">An Error occured.</Alert>
                    ) : ( '' )
                }
                <Button className="pull-right" type="submit" disabled={props.pristine || props.pending}>Submit Extended Information</Button>
            </div>
        </Form>
    )
};

export default reduxForm({
    form: 'stepTwo',
    validate })(StepTwoForm)


// WEBPACK FOOTER //
// ./src/Applications/StepTwoForm.js